export const common = {
  // Navbar
  nav: {
    home: 'Home',
    why: 'Perché',
    applications: 'Applicazioni',
    products: 'Prodotti',
    resources: 'Risorse',
    contacts: 'Contatti',
    askAI: 'Chiedi all\'IA',
    myths: 'Miti vs Fatti',
    o3101: 'O₃ 101',
    safety: 'Sicurezza',
    faq: 'FAQ',
    blog: 'Blog',
  },
  
  // Hero
  hero: {
    badge: 'Educational Hub • Safety-first • Eco-tech',
    title: 'OzoneFusion 2.0',
    subtitle: 'Conoscere l\'ozono. Usarlo in sicurezza.',
    description: 'Il primo hub educativo italiano dedicato all\'ozono: guide chiare, protocolli di sicurezza, FAQ complete e un assistente IA sempre disponibile.',
    cta1: 'Scopri O₃ 101',
    cta2: 'Guida Sicurezza',
    trust: {
      certified: 'Certificato',
      certifiedDesc: 'Standard EU',
      scientific: 'Scientifico',
      scientificDesc: 'Basato su ricerca',
      aiSupport: 'Supporto IA',
      aiSupportDesc: '24/7 disponibile',
      educational: 'Hub Educativo',
      safetyFirst: 'Sicurezza al primo posto',
      ecoTech: 'Tecnologia Eco',
    },
    scroll: 'Scorri per esplorare',
  },
  
  // Why Section
  why: {
    badge: 'Perché OzoneFusion 2.0',
    title: 'Un hub educativo per tutti',
    subtitle: 'Informazione chiara, sicurezza garantita, sostenibilità al centro',
    description: 'Crediamo che la conoscenza sia il primo passo verso un uso sicuro e consapevole dell\'ozono. Ecco perché abbiamo creato questo spazio.',
    cta: 'Inizia da O₃ 101',
    clarity: {
      title: 'Chiarezza',
      description: 'Informazioni scientifiche accessibili a tutti. Niente tecnicismi inutili, solo fatti verificati e spiegazioni chiare.',
    },
    safety: {
      title: 'Sicurezza',
      description: 'Protocolli testati e linee guida certificate. La tua sicurezza è la nostra priorità assoluta.',
    },
    sustainability: {
      title: 'Sostenibilità',
      description: 'Tecnologia eco-friendly che rispetta l\'ambiente. Ozono naturale, zero residui chimici.',
    },
  },
  
  // Myths vs Facts
  myths: {
    badge: 'Facciamo chiarezza',
    title: 'Miti vs Fatti',
    subtitle: 'Sfatiamo i luoghi comuni e scopriamo la verità scientifica sull\'ozono.',
    mythLabel: 'Mito',
    factLabel: 'Fatto',
    footerLead: 'Vuoi saperne di più?',
    footerCta: 'Guida Sicurezza',
    myth1: 'L\'ozono è sempre pericoloso',
    fact1: 'Dipende da dose, tempo, ventilazione e procedure corrette',
    myth2: 'È una soluzione magica',
    fact2: 'È chimica: potente se gestita correttamente con protocolli',
    myth3: 'Non serve ventilare dopo l\'uso',
    fact3: 'La ventilazione è fondamentale: minimo 30-60 minuti',
    myth4: 'Può sostituire la pulizia tradizionale',
    fact4: 'È un complemento: prima pulire, poi sanificare con O₃',
  },
  
  // Safety
  safety: {
    badge: 'Safety First',
    title: 'Le 6 regole d\'oro',
    subtitle: 'Segui questi protocolli fondamentali per un uso sicuro ed efficace dell\'ozono.',
    checklistLead: 'Scarica la',
    checklistBold: 'Checklist Sicurezza completa',
    checklistTail: 'in formato PDF',
    cta: 'Vai alle Risorse',
    rule1: {
      title: 'Ventilazione',
      description: 'Arieggia sempre gli ambienti per 30-60 minuti dopo ogni trattamento. Apri finestre e porte.',
    },
    rule2: {
      title: 'Tempi corretti',
      description: 'Rispetta i tempi di trattamento consigliati. Mai superare le durate indicate dal produttore.',
    },
    rule3: {
      title: 'Concentrazioni sicure',
      description: 'Usa concentrazioni appropriate per ogni applicazione. Più non è sempre meglio.',
    },
    rule4: {
      title: 'Nessuna presenza',
      description: 'Bambini, animali e persone devono lasciare l\'ambiente durante il trattamento.',
    },
    rule5: {
      title: 'Materiali compatibili',
      description: 'Verifica la compatibilità con gomma naturale, alcuni metalli e materiali sensibili.',
    },
    rule6: {
      title: 'Manutenzione',
      description: 'Controlla regolarmente il dispositivo. Sostituisci filtri e componenti secondo le indicazioni.',
    },
  },
  
  // Applications
  applications: {
    badge: 'Dove usarlo',
    title: 'Applicazioni dell\'ozono',
    subtitle: 'Dalla casa al business: scopri come l\'ozono può migliorare igiene e sicurezza.',
    tabHome: 'Casa',
    tabB2B: 'B2B',
    footerLead: 'Non sei sicuro quale applicazione fa per te?',
    footerCta: 'Chiedi al Coach IA',
    discoverProducts: 'Scopri i prodotti',
    homeItems: {
      item1: {
        title: 'Ambienti domestici',
        description: 'Sanifica stanze, armadi, bagni. Elimina odori persistenti e batteri.',
      },
      item2: {
        title: 'Tessuti e vestiti',
        description: 'Igienizza abiti, tende, divani senza prodotti chimici.',
      },
      item3: {
        title: 'Frigorifero e cucina',
        description: 'Mantieni freschi gli alimenti, elimina muffe e cattivi odori.',
      },
      item4: {
        title: 'Auto e veicoli',
        description: 'Sanifica abitacoli, elimina fumo, pollini e allergeni.',
      },
    },
    b2bItems: {
      item1: {
        title: 'Hotel & Hospitality',
        description: 'Sanificazione rapida di camere, lobby, spa. Protocolli certificati per ospiti sicuri.',
      },
      item2: {
        title: 'Lavanderie professionali',
        description: 'Igienizza biancheria, elimina macchie difficili e odori. Risparmio su detergenti.',
      },
      item3: {
        title: 'Uffici e spazi commerciali',
        description: 'Ambienti di lavoro salubri, riduzione assenteismo, aria pulita.',
      },
      item4: {
        title: 'Strutture sanitarie',
        description: 'Sanificazione profonda di ambulatori, sale d\'attesa, strumenti. Standard ospedalieri.',
      },
    },
  },
  
  // Products
  products: {
    title: 'I Nostri Prodotti',
    subtitle: 'Tecnologia italiana per la sanificazione con ozono: soluzioni innovative per casa e business',
    cta: 'Scopri di più',
    tags: {
      washing: 'Lavatrice',
      italy: 'Made in Italy',
      spray: 'Spray Igienizzante',
      portable: 'Portatile',
      generator: 'Generatore',
      purifier: 'Purificatore',
      compact: 'Compatto',
      fridge: 'Frigorifero',
      powerbank: 'Power Bank',
      wellness: 'Wellness',
      pro: 'Professionale',
    },
    items: {
      eco: {
        title: 'Eco OzoneFusion',
        description: 'Il sistema per lavatrice che trasforma l\'acqua in detergente naturale. Elimina il 99.9% di batteri senza detersivi chimici.',
        feat1: 'Riduce detersivi del 90%',
        feat2: 'Risparmio energetico fino al 70%',
        feat3: 'Garanzia 5 anni',
      },
      acqua: {
        title: 'AcquaFusion',
        description: 'Spray portatile che trasforma l\'acqua in potente igienizzante naturale. Perfetto per superfici, oggetti e ambienti.',
        feat1: 'Igienizzazione naturale potente',
        feat2: 'Senza sostanze chimiche',
        feat3: 'Garanzia 2 anni',
      },
      air: {
        title: 'Generatore Ozono O3 Air',
        description: 'Generatore di ozono per sanificazione completa di ambienti. Include gorgogliatore per acqua ozonizzata.',
        feat1: 'Sanificazione aria e acqua',
        feat2: 'Timer 1-60 minuti',
        feat3: 'Garanzia 5 anni',
      },
      mini: {
        title: 'MINI Purificatore d\'Aria',
        description: 'Purificatore compatto con ioni negativi. Perfetto per camera, ufficio o auto fino a 30 m².',
        feat1: 'Ioni negativi naturali',
        feat2: 'Silenzioso e discreto',
        feat3: 'Garanzia 2 anni',
      },
      fresh: {
        title: 'FreshZero',
        description: 'Mini purificatore per frigorifero con power bank integrato. Elimina odori e prolunga la freschezza.',
        feat1: 'Elimina odori e batteri',
        feat2: 'Compatto e portatile',
        feat3: 'Garanzia 2 anni',
      },
      sauna: {
        title: 'OzonoSauna',
        description: 'Sistema professionale per saune e centri benessere. Trattamenti rigeneranti con ozono terapeutico.',
        feat1: 'Trattamenti wellness',
        feat2: 'Uso professionale',
        feat3: 'Certificato e sicuro',
      },
    },
  },
  
  // Resources
  resources: {
    title: 'Risorse gratuite',
    subtitle: 'Scarica guide, checklist e materiali educativi per un uso sicuro dell\'ozono',
    checklist: {
      title: 'Checklist Sicurezza',
      description: 'Lista completa dei controlli da effettuare prima, durante e dopo ogni trattamento.',
      cta: 'Scarica PDF',
    },
    guide: {
      title: 'Guida Rapida O₃',
      description: 'Manuale pratico con tutto ciò che devi sapere per iniziare in sicurezza.',
      cta: 'Scarica PDF',
    },
    poster: {
      title: 'Poster Informativo',
      description: 'Poster A4 da stampare con le regole d\'oro per un uso sicuro dell\'ozono.',
      cta: 'Scarica PDF',
    },
  },
  
  // Blog
  blog: {
    title: 'Educazione & Sicurezza',
    subtitle: 'Articoli, guide e approfondimenti sull\'ozono',
    comingSoon: 'Contenuti in arrivo',
    comingSoonDesc: 'Stiamo preparando articoli e guide approfondite per te. Torna presto!',
    cta: 'Iscriviti alla newsletter',
  },
  
  // AI Assistant
  ai: {
    badge: 'Assistente IA Avanzato',
    title: 'Il tuo Coach di Sicurezza O₃',
    titleHighlight: 'Coach di Sicurezza',
    subtitle: 'Un assistente intelligente sempre al tuo fianco per rispondere a ogni domanda sull\'ozono, la sicurezza d\'uso e le migliori pratiche. Chat o voce, quando vuoi.',
    features: {
      friendly: {
        title: 'Amichevole & Chiaro',
        description: 'Risposte semplici e comprensibili, senza tecnicismi inutili',
      },
      responsible: {
        title: 'Responsabile',
        description: 'Guardrail di sicurezza: nessuna promessa medica, solo informazioni validate',
      },
      knowledge: {
        title: 'Knowledge Base',
        description: 'Accesso a tutte le guide, FAQ e checklist del sito',
      },
      available: {
        title: 'Sempre Disponibile',
        description: 'Chat e voce, 24/7, per rispondere alle tue domande',
      },
    },
    ctaCard: {
      title: 'Pronto a fare domande?',
      description: 'Clicca sul pulsante turchese in basso a destra per iniziare una conversazione. Puoi scrivere o parlare direttamente con il Coach.',
      cta: 'Apri il Coach IA',
    },
    examplesTitle: 'Oppure prova con una di queste domande:',
    question1: 'Come funziona l\'ozono?',
    question2: 'È sicuro per la mia casa?',
    question3: 'Quanto tempo devo ventilare?',
    question4: 'Posso usarlo con animali?',
    question5: 'Quali concentrazioni sono sicure?',
    question6: 'Come sanificare i tessuti?',
    safetyNotice: {
      title: 'Nota importante sulla sicurezza',
      description: 'Il Coach IA fornisce informazioni educative basate su standard e ricerca scientifica. Non offre consulenze mediche o terapeutiche. Per domande cliniche o di salute, consulta sempre un professionista qualificato. Il Coach ti guiderà verso le risorse giuste.',
    },
  },
  
  // About
  about: {
    title: 'Chi siamo',
    subtitle: 'Purevital / OzoneFusion',
    mission: 'La nostra missione',
    missionText: 'Rendere la tecnologia dell\'ozono accessibile, sicura e comprensibile per tutti. Crediamo in un futuro più pulito attraverso l\'educazione e l\'innovazione responsabile.',
    values: 'I nostri valori',
    value1: 'Trasparenza scientifica',
    value2: 'Sicurezza al primo posto',
    value3: 'Sostenibilità ambientale',
    value4: 'Innovazione responsabile',
  },
  
  // Contact
  contact: {
    title: 'Contattaci',
    subtitle: 'Siamo qui per rispondere alle tue domande',
    name: 'Nome',
    email: 'Email',
    phone: 'Telefono',
    message: 'Messaggio',
    send: 'Invia messaggio',
    whatsapp: 'Scrivici su WhatsApp',
    emailUs: 'Inviaci un\'email',
    newsletter: 'Iscriviti alla newsletter',
    newsletterDesc: 'Ricevi aggiornamenti, guide e consigli sulla sicurezza',
    subscribe: 'Iscriviti',
    success: 'Messaggio inviato con successo!',
    error: 'Errore nell\'invio. Riprova.',
  },
  
  // Footer
  footer: {
    tagline: 'Educazione, sicurezza e tecnologia per un futuro più pulito',
    explore: 'Esplora',
    education: 'Educazione',
    company: 'Azienda',
    support: 'Supporto',
    legal: 'Legale',
    contactUs: 'Contattaci',
    faq: 'FAQ',
    guides: 'Sicurezza & Linee Guida',
    community: 'Community',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy',
    disclaimer: 'Disclaimer',
    terms: 'Termini e Condizioni',
    allProducts: 'Tutti i Prodotti',
    compareProducts: 'Confronta Prodotti',
    rights: 'Tutti i diritti riservati',
    poweredBy: 'Powered by Readdy',
  },
  
  // Common
  common: {
    readMore: 'Leggi di più',
    learnMore: 'Scopri di più',
    download: 'Scarica',
    close: 'Chiudi',
    back: 'Indietro',
    next: 'Avanti',
    loading: 'Caricamento...',
  },
};
